<template>
  <div id="hres7de-detail-tab1" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#tab1">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES7DEP1']['40'] }}
      </h3>
    </div>
    <div id="tab1" class="panel-collapse collapse tab-detail">
      <div class="panel-body">
        <div class="detail detail-responsive">

          <div class="col-md-6">
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRES7DEP1']['50'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ detailTab1.desc_codtparg }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRES7DEP1']['60'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ detailTab1.codcate }} - {{ detailTab1.desc_codcate }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRES7DEP1']['70'] }}</label>
                <div class="col-md-6">
                  <div class="detail-text width-100 txtarea-width response-full-width">{{ detailTab1.destrfu1 }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRES7DEP1']['80'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ setDateOutput(detailTab1.dtetrst) }} - {{ setDateOutput(detailTab1.dtetren) }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRES7DEP1']['90'] }}</label>
                <div class="col-md-6 ">
                  <div class="input-group margin-b-0">
                    <input class="form-control" readonly v-model="detailTab1.qtytrhur" />
                    <div class="input-group-addon">{{ labels['HRES7DEP1']['100'] }}</div>
                  </div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRES7DEP1']['110'] }}</label>
                <div class="col-md-6">
                  <div class="input-group margin-b-0">
                    <input class="form-control" readonly v-model="detailTab1.amttrexp" />
                    <div class="input-group-addon">{{ labels['HRES7DEP1']['120'] }}</div>
                  </div>
                </div>
              </div>
            </form>
            
          </div>

          <div class="col-md-6">
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRES7DEP1']['130'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ detailTab1.codinsts }} - {{ detailTab1.nam_codinsts }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">             
                <label class="col-md-4 control-label">{{ labels['HRES7DEP1']['140'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ detailTab1.codhotel }} - {{ detailTab1.nam_codhotel }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">             
                <label class="col-md-4 control-label">{{ labels['HRES7DEP1']['150'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ detailTab1.codinst }} - {{ detailTab1.nam_codinst }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">             
                <label class="col-md-4 control-label">{{ labels['HRES7DEP1']['160'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ detailTab1.flgupdcmp }}</div>
                </div>
              </div>
            </form> 
            <form class="form-horizontal">
              <div class="form-group margin-b-5">             
                <label class="col-md-4 control-label">{{ labels['HRES7DEP1']['190'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ detailTab1.numcert }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">             
                <label class="col-md-4 control-label">{{ labels['HRES7DEP1']['200'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ setDateOutput(detailTab1.dtecert) }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">             
                <label class="col-md-4 control-label">{{ labels['HRES7DEP1']['210'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ detailTab1.desc_typtrain }}</div>
                </div>
              </div>
            </form>       
          </div>

          <div class="col-md-12">
            <div class="detail-header"><u>{{ labels['HRES7DEP1']['220'] }}</u></div>
          </div>
          <div class="col-md-6">
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRES7DEP1']['230'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ detailTab1.qtyprescr }}</div>
                </div>
              </div>
            </form>

            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRES7DEP1']['240'] }}</label>
                  <div class="col-md-6 ">
                    <div class="form-control readonly-field-color">{{ detailTab1.qtytotscr }}</div>
                  </div>
                  <template v-if="detailTab1.qtytotscr !== '' && detailTab1.dteexam !== ''">
                    <div class="col-md-2 ">
                      <button type="button" class="btn bg-color-skin pull-right" data-toggle="modal" data-target="#hres7de-popup-tab1" @click="togglePopupDetailTab1()">{{ labelsButton['view'] }}</button>  
                    </div>
                  </template>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRES7DEP1']['260'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ detailTab1.flgtrevl }}</div>
                </div>
              </div>
            </form>
          </div>
          <div class="col-md-6">
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRES7DEP1']['250'] }}</label>
                <div class="col-md-6">
                  <div class="detail-text width-100 txtarea-width response-full-width">{{ detailTab1.descommt }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRES7DEP1']['290'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ detailTab1.dtecntr }}</div>
                </div>
              </div>
            </form>
          </div>


        </div>
      </div>
    </div>

    <popup  :labels="labels"
            :nowLang="nowLang"
            :detailTab1PopupBtn1to3Columns="detailTab1PopupBtn1to3Columns"
            :detailTab1PopupBtn4Columns="detailTab1PopupBtn4Columns"
            :detailTab1Popup="detailTab1Popup" />

  </div>

  </div>
</template>

<script>
import popup from 'components/hres7de/popupTab1'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hres7de-detail-tab1',
  props: [
    'labels',
    'labelsButton',
    'nowLang',
    'detailTab1',
    'detailTab1Popup',
    'detailTab1PopupBtn1to3Columns',
    'detailTab1PopupBtn4Columns',
    'receivedHres7deDetailTab1Popup'
  ],
  methods: {
    togglePopupDetailTab1 () {
      this.receivedHres7deDetailTab1Popup(this.detailTab1)
    },
    calResultScore (dataGroups) {
      return dataGroups.map((dataGroup) => {
        return parseFloat(dataGroup.qtyscor)
      }).reduce((a, b) => {
        return parseFloat(a) + parseFloat(b)
      })
    },
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  },
  components: {
    popup
  }
}
</script>


// WEBPACK FOOTER //
// detailTab1.vue?0c1974a5